
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 28","stroke":"currentColor","fill":"transparent"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 15v6c0 1.656-1.344 3-3 3H3c-1.656 0-3-1.344-3-3V10c0-4.406 3.594-8 8-8h1c.547 0 1 .453 1 1v2c0 .547-.453 1-1 1H8c-2.203 0-4 1.797-4 4v.5A1.5 1.5 0 005.5 12H9c1.656 0 3 1.344 3 3zm14 0v6c0 1.656-1.344 3-3 3h-6c-1.656 0-3-1.344-3-3V10c0-4.406 3.594-8 8-8h1c.547 0 1 .453 1 1v2c0 .547-.453 1-1 1h-1c-2.203 0-4 1.797-4 4v.5a1.5 1.5 0 001.5 1.5H23c1.656 0 3 1.344 3 3z"}})])
          )
        }
      }
    